import { ReactNode } from 'react';
import Badge from 'antd/es/badge';
import { t } from 'i18next';

// Using the release notes to determine the alertCount on the Release Notes menu item
import releaseNotesJson from 'routes/ReleaseNotesPage/releaseNotes.json';
import masterReleaseNotesJson from 'routes/MasterReleaseNotesPage/masterReleaseNotes.js';
import { UserFilledSvg } from 'components/svgs/UserFilledSvg/UserFilledSvg';
import { CameraOutlinedSvg } from 'components/svgs/CameraOutlinedSvg/CameraOutlinedSvg';
import { HomeFilledSvg } from 'components/svgs/HomeFilledSvg/HomeFilledSvg';
import { HomeOutlinedSvg } from 'components/svgs/HomeOutlinedSvg/HomeOutlinedSvg';
import { CameraFilledSvg } from 'components/svgs/CameraFilledSvg/CameraFilledSvg';
import { UserOutlinedSvg } from 'components/svgs/UserOutlinedSvg/UserOutlinedSvg';
import { LocationOutlinedSvg } from 'components/svgs/LocationOutlinedSvg/LocationOutlinedSvg';
import { LocationFilledSvg } from 'components/svgs/LocationFilledSvg/LocationFilledSvg';
import { DevicesOutlinedSvg } from 'components/svgs/DevicesOutlinedSvg/DevicesOutlinedSvg';
import { DeviceFilledSvg } from 'components/svgs/DeviceFilledSvg/DeviceFilledSvg';
import { PuzzleOutlinedSvg } from 'components/svgs/PuzzleOutlinedSvg/PuzzleOutlinedSvg';
import { PuzzleFilledSvg } from 'components/svgs/PuzzleFilledSvg/PuzzleFilledSvg';
import { SettingOutlinedSvg } from 'components/svgs/SettingOutlinedSvg/SettingOutlinedSvg';
import { SettingFilledSvg } from 'components/svgs/SettingFilledSvg/SettingFilledSvg';
import { AdminFilledSvg } from 'components/svgs/AdminFilledSvg/AdminFilledSvg';
import { QuestionMarkOutlinedSvg } from 'components/svgs/QuestionMarkOutlinedSvg/QuestionMarkOutlinedSvg';
import { QuestionMarkFilledSvg } from 'components/svgs/QuestionMarkFilledSvg/QuestionMarkFilledSvg';
import { DocumentOutlinedSvg } from 'components/svgs/DocumentOutlinedSvg/DocumentOutlinedSvg';
import { DocumentFilledSvg } from 'components/svgs/DocumentFilledSvg/DocumentFilledSvg';
import { FileOutlinedSvg } from 'components/svgs/FileOutlinedSvg/FileOutlinedSvg';
import { FileFilledSvg } from 'components/svgs/FileFilledSvg/FileFilledSvg';
import { AdminOutlinedSvg } from 'components/svgs/AdminOutlinedSvg/AdminOutlinedSvg';
import { UserGroupOutlineSvg } from 'components/svgs/UserGroupOutlineSvg/UserGroupOutlineSvg';
import { UserGroupFilledSvg } from 'components/svgs/UserGroupFilledSvg/UserGroupFilledSvg';

import {
  appMarketplaceRoute,
  alarmDashboardRoute,
  hardwareDashboardRoute,
  entryDashboardRoute,
  buildingsRoute,
  buildingsCreateRoute,
  buildingsEditRoute,
  licensesRoute,
  usersTableRoute,
  userSchedulesTableRoute,
  userSchedulesCreateRoute,
  userSchedulesEditRoute,
  userCustomFieldsTableRoute,
  userCustomFieldsCreateRoute,
  userCustomFieldsEditRoute,
  userCredentialsManagementRoute,
  presenceReportRoute,
  usersImportRoute,
  rolesRoute,
  sitesTableRoute,
  sitesCreateRoute,
  sitesEditRoute,
  zonesTableRoute,
  zonesCreateRoute,
  zonesEditDetailsRoute,
  zonesEditAntiPassbackRoute,
  entriesTableRoute,
  entryStatesTableRoute,
  entryStatesCreateRoute,
  entryStatesEditRoute,
  entrySchedulesTableRoute,
  entrySchedulesCreateRoute,
  entrySchedulesEditRoute,
  acusTableRoute,
  acusCreateRoute,
  acusPortsRoute,
  acusEditRoute,
  readersTableRoute,
  readersCreateRoute,
  readersEditRoute,
  allegionReadersTableRoute,
  thirdPartyReadersEditRoute,
  activityLogsRoute,
  userActivityRoute,
  entryActivityRoute,
  userActivitySummaryRoute,
  entryActivitySummaryRoute,
  entryAccessAuditRoute,
  userAccessAuditRoute,
  portalAuditReportRoute,
  integrationsRoute,
  integrationsIdentityProviderGsuite,
  integrationsIdentityProviderAzure,
  integrationsIdentityProviderOkta,
  integrationsIdentityProviderOnelogin,
  mobileAppSettingsRoute,
  mobileAppBadgeUiRoute,
  badgeTemplatesTablePageRoute,
  intercomUserDirectoryRoute,
  quickStartRoute,
  accountPageRoute,
  releaseNotesRoute,
  masterDashboardRoute,
  masterOrgTableRoute,
  masterOrgEditRoute,
  masterOrgEditPackageRoute,
  masterOrgEditFeatureFlagRoute,
  masterOrgCreateRoute,
  masterCancelsTableRoute,
  masterIdentitiesTableRoute,
  masterIdentitiesEditRoute,
  masterIdentitiesEditSecurityRoute,
  masterIdentitiesCreateRoute,
  masterRolesTableRoute,
  masterRolesEditRoute,
  masterRolesCreateRoute,
  masterAcusTableRoute,
  masterAcusEditRoute,
  masterEntriesTableRoute,
  masterThirdPartyDevicesRoute,
  masterAllegionFobsRoute,
  masterFeatureFlagsTableRoute,
  masterFeatureFlagsEditRoute,
  masterFeatureFlagsCreateRoute,
  masterPortalAuditReportRoute,
  masterAcuSoftwareReportRoute,
  masterMobileWalletReportRoute,
  myAppsTableRoute,
  masterReleaseNotesRoute,
  alertSettingsRoute,
  lockdownTableRoute,
  camerasRoute,
  cameraDetailsRoute,
  camerasV2Route,
  cameraDetailsV2Route,
  lockdownCreateRoute,
  lockdownEditRoute,
  lockdownEditConfigRoute,
  requiredTermsRoute,
  subscriptionsTableRoute,
  subscriptionsCreateRoute,
  subscriptionsEditRoute,
  visualActivityReportRoute,
  wirelessLockGatewaysTableRoute,
  wirelessLockTemplatesRoute,
  wirelessLocksTableRoute,
  allegionWirelessLocksTableRoute,
  assaAbloyWirelessLocksTableRoute,
  wirelessLocksEditRoute,
  deviceUpdateManagement,
  customDashboardsRoute,
  scheduledReportsRoute,
  scheduledReportsCreateRoute,
  scheduledReportsEditRoute,
  cameraDeeplinkRedirectRoute,
  cameraDeeplinkRedirectV2Route,
  alarmEditRoute,
  alarmReportRoute,
  musterReportsRoute,
  accessGroupsRoute,
  activityDashboardRoute,
  videoIntercomReadersRoute,
  videoReadersRoute,
  occupancyReportRoute,
  alarmConfigurationsRoute,
  partnerDashboardRoute,
  partnerStoreRoute,
  partnerOrgTableRoute,
  partnerOrgCreateRoute,
  partnerOrgEditRoute,
  partnerOrgEditPackageRoute,
  partnerSubscriptionRenewalsTableRoute,
  partnerRequestsTableRoute,
  partnerAcusTableRoute,
  partnerAcusEditRoute,
  partnerThirdPartyDevicesRoute,
  partnerEntriesTableRoute,
  partnerBillingRoute,
  dashboardContainerRoute,
  mapsDashboardRoute,
  allegionWirelessLockGatewaysTableRoute,
  assaAbloyWirelessLockGatewaysTableRoute,
  dashboardContainerRouteV2,
  musterDashboardRoute,
} from '../routes/constants';

export interface OpRawMenuItemType {
  key: string;
  title: string;
  route?: string | null;
  scope?: string[];
  icon?: ReactNode;
  selectedIcon?: ReactNode;
  hidden?: boolean;
  items?: OpRawMenuItemType[];
  external?: boolean;
  admin?: boolean;
  requiredFeatureCode?: string | string[];
  action?: string;
  type?: 'group';
}

interface CreateRawMenuItemsOptions {
  isLicenseBased: boolean;
  hasAppMarketplace: boolean;
  billingMode: string;
  isUnified: boolean;
  isWirelessLockTemplatesEnabled: boolean;
  isCamerasV2Enabled: boolean;
}

const DEFAULT_CREATE_RAW_MENU_ITEMS_OPTIONS: CreateRawMenuItemsOptions = {
  isLicenseBased: false,
  hasAppMarketplace: false,
  billingMode: '',
  isUnified: false,
  isWirelessLockTemplatesEnabled: false,
  isCamerasV2Enabled: false,
};

export const createRawMenuItems = (
  mergedOpenpathConfig: Record<string, any> = {},
  {
    isLicenseBased,
    hasAppMarketplace,
    billingMode,
    isUnified,
    isWirelessLockTemplatesEnabled,
    isCamerasV2Enabled,
  }: CreateRawMenuItemsOptions = DEFAULT_CREATE_RAW_MENU_ITEMS_OPTIONS,
) => {
  const seenReleaseNotesCount = localStorage.getItem('release-notes-count');
  const seenMasterReleaseNotesCount = localStorage.getItem(
    'master-release-notes-count',
  );

  const newReleaseNotesCount =
    releaseNotesJson.length - Number(seenReleaseNotesCount);
  const newMasterReleaseNotesCount =
    masterReleaseNotesJson().length - Number(seenMasterReleaseNotesCount);

  return [
    // TODO: Remove 'Home' in favor of 'Home V2'. Merge them?
    {
      key: dashboardContainerRoute,
      get title() {
        return t('Home');
      },
      route: dashboardContainerRoute,
      scope: [
        'o{orgId}-dash:r',
        'o{orgId}-dash:w',
        'o{orgId}-dashActivity:r',
        'o{orgId}-dashActivity:w',
        'o{orgId}-dashAlarm:r',
        'o{orgId}-dashAlarm:w',
        'o{orgId}-dashEntry:r',
        'o{orgId}-dashEntry:w',
        'o{orgId}-hw:r',
        'o{orgId}-hw:w',
        'o{orgId}-dashCust:r',
        'o{orgId}-dashCust:w',
        'o:w',
        'o:r',
        's-o:r',
        's-o:w',
      ],
      icon: <HomeOutlinedSvg />,
      selectedIcon: <HomeFilledSvg />,
      items: [
        {
          key: activityDashboardRoute,
          get title() {
            return t('Activity dashboard');
          },
          route: activityDashboardRoute,
          scope: [
            'o{orgId}-dash:r',
            'o{orgId}-dash:w',
            'o{orgId}-dashActivity:r',
            'o{orgId}-dashActivity:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          hidden: true,
        },
        {
          key: alarmDashboardRoute,
          get title() {
            return t('Alarms dashboard');
          },
          route: alarmDashboardRoute,
          scope: [
            'o{orgId}-dash:r',
            'o{orgId}-dash:w',
            'o{orgId}-dashAlarm:r',
            'o{orgId}-dashAlarm:w',
            'o:w',
            'o:r',
          ],
          hidden: true,
        },
        {
          key: entryDashboardRoute,
          get title() {
            return t('Entry dashboard');
          },
          route: entryDashboardRoute,
          scope: [
            'o{orgId}-dash:r',
            'o{orgId}-dash:w',
            'o{orgId}-dashEntry:r',
            'o{orgId}-dashEntry:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          hidden: true,
        },
        {
          key: hardwareDashboardRoute,
          get title() {
            return t('Device dashboard');
          },
          route: hardwareDashboardRoute,
          scope: [
            'o{orgId}-dash:r',
            'o{orgId}-dash:w',
            'o{orgId}-hw:r',
            'o{orgId}-hw:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          hidden: true,
        },
        {
          key: mapsDashboardRoute,
          get title() {
            return t('Maps');
          },
          route: mapsDashboardRoute,
          scope: [
            'o{orgId}-dash:r',
            'o{orgId}-dash:w',
            'o{orgId}-map:r',
            'o{orgId}-map:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          hidden: true,
        },
        {
          key: musterDashboardRoute,
          get title() {
            return t('Muster dashboard');
          },
          route: musterDashboardRoute,
          scope: [
            'o{orgId}-dash:r',
            'o{orgId}-dash:w',
            'o{orgId}-musterReport:r',
            'o{orgId}-musterReport:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          hidden: true,
          requiredFeatureCode: 'musterReport',
        },
        {
          key: customDashboardsRoute,
          get title() {
            return t('Custom dashboard');
          },
          route: customDashboardsRoute,
          scope: [
            'o{orgId}-dash:r',
            'o{orgId}-dash:w',
            'o{orgId}-hw:r',
            'o{orgId}-hw:w',
            'o{orgId}-dashCust:r',
            'o{orgId}-dashCust:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          hidden: true,
        },
      ],
    },
    {
      hidden: true,
      key: dashboardContainerRouteV2,
      get title() {
        return t('Home V2');
      },
      route: dashboardContainerRouteV2,
      scope: [
        'o{orgId}-dash:r',
        'o{orgId}-dash:w',
        'o{orgId}-dashActivity:r',
        'o{orgId}-dashActivity:w',
        'o{orgId}-dashAlarm:r',
        'o{orgId}-dashAlarm:w',
        'o{orgId}-dashEntry:r',
        'o{orgId}-dashEntry:w',
        'o{orgId}-hw:r',
        'o{orgId}-hw:w',
        'o{orgId}-dashCust:r',
        'o{orgId}-dashCust:w',
        'o:w',
        'o:r',
        's-o:r',
        's-o:w',
      ],
      icon: <HomeOutlinedSvg />,
      selectedIcon: <HomeFilledSvg />,
      items: [],
    },
    // TODO - Remove this once we no longer have partner center in CC (playing it safe)
    {
      key: 'partner-center',
      get title() {
        return t('Partners');
      },
      icon: <UserGroupOutlineSvg />,
      selectedIcon: <UserGroupFilledSvg />,
      scope: [
        'o{orgId}-erpParentStore:w',
        'o{orgId}-erpParentCenter:w',
        'o:w',
        'o:r',
        's-o:r',
        's-o:w',
      ],
      requiredFeatureCode: 'subOrgs',
      items: [
        {
          key: partnerDashboardRoute,
          get title() {
            return t('Dashboard');
          },
          route: partnerDashboardRoute,
          scope: ['o:w', 'o:r', 's-o:r', 's-o:w'],
          requiredFeatureCode: 'subOrgs',
        },
        {
          key: partnerStoreRoute,
          get title() {
            return t('Store');
          },
          route: partnerStoreRoute,
          scope: ['o{orgId}-erpParentStore:w', 'o:w', 'o:r'], // no s-o scopes here since users specifically need the erpParentStore permission here
          requiredFeatureCode: 'subOrgs',
        },
        {
          key: partnerOrgTableRoute,
          get title() {
            return t('Customers');
          },
          route: partnerOrgTableRoute,
          scope: ['o:r', 'o:w', 's-o:r', 's-o:w'],
          requiredFeatureCode: 'subOrgs',

          items: [
            {
              key: partnerOrgCreateRoute,
              get title() {
                return t('Create organization');
              },
              route: partnerOrgCreateRoute,
              scope: ['o:r', 'o:w', 's-o:r', 's-o:w'],
              requiredFeatureCode: 'subOrgs',
              hidden: true,
            },
            {
              key: partnerOrgEditRoute,
              get title() {
                return t('Edit organization');
              },
              route: partnerOrgEditRoute,
              scope: ['o:r', 'o:w', 's-o:r', 's-o:w'],
              requiredFeatureCode: 'subOrgs',
              hidden: true,
            },
            {
              key: partnerOrgEditPackageRoute,
              get title() {
                return t('Edit organization package');
              },
              route: partnerOrgEditPackageRoute,
              scope: ['o:r', 'o:w', 's-o:r', 's-o:w'],
              requiredFeatureCode: 'subOrgs',
              hidden: true,
            },
          ],
        },
        {
          key: partnerSubscriptionRenewalsTableRoute,
          get title() {
            return t('Renewals');
          },
          route: partnerSubscriptionRenewalsTableRoute,
          scope: ['o{orgId}-erpParentStore:w', 'o:w', 'o:r'], // no s-o scopes here since users specifically need the erpParentStore permission here
          requiredFeatureCode: 'subOrgs',
        },
        {
          key: partnerRequestsTableRoute,
          get title() {
            return t('License requests');
          },
          route: partnerRequestsTableRoute,
          scope: ['o:w', 'o:r', 's-o:r', 's-o:w'],
          requiredFeatureCode: 'subOrgs',
        },
        {
          key: partnerAcusTableRoute,
          get title() {
            return t('ACUs');
          },
          route: partnerAcusTableRoute,
          scope: ['o:r', 'o:w', 's-o:r', 's-o:w'],
          requiredFeatureCode: 'subOrgs',
          items: [
            {
              key: partnerAcusEditRoute,
              get title() {
                return t('ACUs');
              },
              route: partnerAcusEditRoute,
              scope: ['o:r', 'o:w', 's-o:r', 's-o:w'],
              requiredFeatureCode: 'subOrgs',
              hidden: true,
            },
          ],
        },
        {
          key: partnerThirdPartyDevicesRoute,
          get title() {
            return t('3rd-party devices');
          },
          route: partnerThirdPartyDevicesRoute,
          scope: ['o:r', 'o:w', 's-o:r', 's-o:w'],
          requiredFeatureCode: 'subOrgs',
        },
        {
          key: partnerEntriesTableRoute,
          get title() {
            return t('Entries');
          },
          route: partnerEntriesTableRoute,
          scope: ['o:r', 'o:w', 's-o:r', 's-o:w'],
          requiredFeatureCode: 'subOrgs',
        },
        {
          key: partnerBillingRoute,
          get title() {
            return t('Billing');
          },
          route: partnerBillingRoute,
          scope: ['o{orgId}-erpParentCenter:w', 'o:w', 'o:r'], // no s-o scopes here since users specifically need the erpParentStore permission here
          requiredFeatureCode: 'subOrgs',
        },
        {
          key: 'partner-marketing',
          get title() {
            return t('Marketing');
          },
          route: 'https://vsapartners.motorolasolutions.com/s/',
          scope: ['o:r', 'o:w', 's-o:r', 's-o:w'],
          requiredFeatureCode: 'subOrgs',
          external: true,
        },
        {
          key: 'partner-training',
          get title() {
            return t('Training');
          },
          route: 'https://learningcenter.motorolasolutions.com/',
          scope: ['o:r', 'o:w', 's-o:r', 's-o:w'],
          requiredFeatureCode: 'subOrgs',
          external: true,
        },
      ],
      hidden: isUnified,
    },
    {
      key: camerasRoute,
      hidden: isCamerasV2Enabled,
      get title() {
        return t('Cameras');
      },
      route: camerasRoute,
      icon: <CameraOutlinedSvg />,
      selectedIcon: <CameraFilledSvg />,
      scope: [
        'o:w',
        's-o:w',
        'o{orgId}-videoProviderLive:w', // they can see because they have "play back videoProvider live" scope
        'o{orgId}-videoProviderPlayback:w', // they can see because they have "play back videoProvider clips" scope
        'o{orgId}-opvideoDevice:w', // they can see it because they have "fine tune video settings" scope
        'o-supportVideo:w', // they can see it because they have support scope
      ],
      items: [
        {
          key: cameraDetailsRoute,
          get title() {
            return t('Camera details');
          },
          route: cameraDetailsRoute,
          scope: [
            'o:w',
            's-o:w',
            'o{orgId}-videoProviderLive:w', // they can see because they have "play back videoProvider live" scope
            'o{orgId}-videoProviderPlayback:w', // they can see because they have "play back videoProvider clips" scope
            'o{orgId}-opvideoDevice:w', // they can see it because they have "fine tune video settings" scope
            'o-supportVideo:w', // they can see it because they have support scope
          ],
          hidden: true,
        },
        {
          key: cameraDeeplinkRedirectRoute,
          get title() {
            return t('Camera deeplink redirect');
          },
          route: cameraDeeplinkRedirectRoute,
          scope: [
            'o:w',
            's-o:w',
            'o{orgId}-videoProviderLive:w', // they can see because they have "play back videoProvider live" scope
            'o{orgId}-videoProviderPlayback:w', // they can see because they have "play back videoProvider clips" scope
            'o{orgId}-opvideoDevice:w', // they can see it because they have "fine tune video settings" scope
            'o-supportVideo:w', // they can see it because they have support scope
          ],
          hidden: true,
        },
      ],
    },

    {
      key: camerasV2Route,
      hidden: !isCamerasV2Enabled,
      get title() {
        return t('Cameras');
      },
      route: camerasV2Route,
      icon: <CameraOutlinedSvg />,
      selectedIcon: <CameraFilledSvg />,
      scope: [
        'o:w',
        's-o:w',
        'o{orgId}-videoProviderLive:w', // they can see because they have "play back videoProvider live" scope
        'o{orgId}-videoProviderPlayback:w', // they can see because they have "play back videoProvider clips" scope
        'o{orgId}-opvideoDevice:w', // they can see it because they have "fine tune video settings" scope
        'o-supportVideo:w', // they can see it because they have support scope
      ],
      items: [
        {
          key: cameraDetailsV2Route,
          get title() {
            return t('Camera details V2');
          },
          route: cameraDetailsV2Route,
          scope: [
            'o:w',
            's-o:w',
            'o{orgId}-videoProviderLive:w', // they can see because they have "play back videoProvider live" scope
            'o{orgId}-videoProviderPlayback:w', // they can see because they have "play back videoProvider clips" scope
            'o{orgId}-opvideoDevice:w', // they can see it because they have "fine tune video settings" scope
            'o-supportVideo:w', // they can see it because they have support scope
          ],
          hidden: true,
        },
        {
          key: cameraDeeplinkRedirectV2Route,
          get title() {
            return t('Camera deeplink redirect V2');
          },
          route: cameraDeeplinkRedirectV2Route,
          scope: [
            'o:w',
            's-o:w',
            'o{orgId}-videoProviderLive:w', // they can see because they have "play back videoProvider live" scope
            'o{orgId}-videoProviderPlayback:w', // they can see because they have "play back videoProvider clips" scope
            'o{orgId}-opvideoDevice:w', // they can see it because they have "fine tune video settings" scope
            'o-supportVideo:w', // they can see it because they have support scope
          ],
          hidden: true,
        },
      ],
    },
    {
      key: 'primary-users',
      get title() {
        return t('Users');
      },
      icon: <UserOutlinedSvg />,
      selectedIcon: <UserFilledSvg />,
      scope: [
        'o{orgId}-user:r',
        'o{orgId}-user:w',
        'o:w',
        'o:r',
        's-o:r',
        's-o:w',
        's-o-video:r',
        's-o-video:w',
        'o-user:r',
        'o-user:w',
      ],
      items: [
        {
          key: usersTableRoute,
          get title() {
            return t('Users');
          },
          route: usersTableRoute,
          scope: [
            'o{orgId}-user:r',
            'o{orgId}-user:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
            's-o-video:r',
            's-o-video:w',
            'o-user:r',
            'o-user:w',
          ],
        },
        {
          key: usersImportRoute,
          get title() {
            return t('Import');
          },
          route: usersImportRoute,
          scope: [
            'o{orgId}-user:r',
            'o{orgId}-user:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
            's-o-video:r',
            's-o-video:w',
          ],
        },
        {
          key: accessGroupsRoute,
          get title() {
            return t('Access groups');
          },
          route: accessGroupsRoute,
          scope: [
            'o{orgId}-user:r',
            'o{orgId}-user:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
            's-o-video:r',
            's-o-video:w',
            'o-user:r',
            'o-user:w',
          ],
        },
        {
          key: rolesRoute,
          get title() {
            return t('Roles');
          },
          route: rolesRoute,
          scope: [
            'o{orgId}-role:r',
            'o{orgId}-role:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
            's-o-video:r',
            's-o-video:w',
            'o-role:r',
            'o-role:w',
          ],
        },
        {
          key: userSchedulesTableRoute,
          get title() {
            return t('Schedules');
          },
          route: userSchedulesTableRoute,
          scope: [
            'o{orgId}-user:r',
            'o{orgId}-user:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          items: [
            {
              key: userSchedulesCreateRoute,
              get title() {
                return t('Create schedule');
              },
              route: userSchedulesCreateRoute,
              scope: [
                'o{orgId}-user:r',
                'o{orgId}-user:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: userSchedulesEditRoute,
              get title() {
                return t('Edit schedule');
              },
              route: userSchedulesEditRoute,
              scope: [
                'o{orgId}-user:r',
                'o{orgId}-user:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
          ],
        },
        {
          key: userCustomFieldsTableRoute,
          get title() {
            return t('Custom fields');
          },
          route: userCustomFieldsTableRoute,
          scope: [
            'o{orgId}-user:r',
            'o{orgId}-user:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          items: [
            {
              key: userCustomFieldsCreateRoute,
              get title() {
                return t('Create schedule');
              },
              route: userCustomFieldsCreateRoute,
              scope: [
                'o{orgId}-user:r',
                'o{orgId}-user:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: userCustomFieldsEditRoute,
              get title() {
                return t('Edit schedule');
              },
              route: userCustomFieldsEditRoute,
              scope: [
                'o{orgId}-user:r',
                'o{orgId}-user:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
          ],
        },
      ],
    },

    {
      key: 'primary-sites',
      get title() {
        return t('Sites');
      },
      icon: <LocationOutlinedSvg />,
      selectedIcon: <LocationFilledSvg />,
      scope: [
        'o{orgId}-site:r',
        'o{orgId}-site:w',
        'o{orgId}-siteGeneral:r',
        'o{orgId}-siteGeneral:w',
        'o:w',
        'o:r',
        's-o:r',
        's-o:w',
      ],
      items: [
        {
          key: sitesTableRoute,
          get title() {
            return t('Sites');
          },
          route: sitesTableRoute,
          scope: [
            'o{orgId}-site:r',
            'o{orgId}-site:w',
            'o{orgId}-siteGeneral:r',
            'o{orgId}-siteGeneral:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          items: [
            {
              key: sitesCreateRoute,
              get title() {
                return t('Create site');
              },
              route: sitesCreateRoute,
              scope: [
                'o{orgId}-site:r',
                'o{orgId}-site:w',
                'o{orgId}-siteGeneral:r',
                'o{orgId}-siteGeneral:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: sitesEditRoute,
              get title() {
                return t('Edit site');
              },
              route: sitesEditRoute,
              scope: [
                'o{orgId}-site:r',
                'o{orgId}-site:w',
                'o{orgId}-siteGeneral:r',
                'o{orgId}-siteGeneral:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
          ],
        },
        {
          key: buildingsRoute,
          get title() {
            return t('Buildings');
          },
          route: buildingsRoute,
          scope: [
            'o{orgId}-site:r',
            'o{orgId}-site:w',
            'o{orgId}-building:r',
            'o{orgId}-building:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          items: [
            {
              key: buildingsCreateRoute,
              get title() {
                return t('Create building');
              },
              route: buildingsCreateRoute,
              scope: [
                'o{orgId}-site:r',
                'o{orgId}-site:w',
                'o{orgId}-building:r',
                'o{orgId}-building:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: buildingsEditRoute,
              get title() {
                return t('Edit building');
              },
              route: buildingsEditRoute,
              scope: [
                'o{orgId}-site:r',
                'o{orgId}-site:w',
                'o{orgId}-building:r',
                'o{orgId}-building:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
          ],
        },
        {
          key: zonesTableRoute,
          get title() {
            return t('Zones');
          },
          route: zonesTableRoute,
          scope: [
            'o{orgId}-site:r',
            'o{orgId}-site:w',
            'o{orgId}-siteGeneral:r',
            'o{orgId}-siteGeneral:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          items: [
            {
              key: zonesCreateRoute,
              get title() {
                return t('Create zone');
              },
              route: zonesCreateRoute,
              scope: [
                'o{orgId}-site:r',
                'o{orgId}-site:w',
                'o{orgId}-siteGeneral:r',
                'o{orgId}-siteGeneral:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: zonesEditDetailsRoute,
              get title() {
                return t('Edit zone');
              },
              route: zonesEditDetailsRoute,
              scope: [
                'o{orgId}-site:r',
                'o{orgId}-site:w',
                'o{orgId}-siteGeneral:r',
                'o{orgId}-siteGeneral:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: zonesEditAntiPassbackRoute,
              get title() {
                return t('Edit zone');
              },
              route: zonesEditAntiPassbackRoute,
              scope: [
                'o{orgId}-site:r',
                'o{orgId}-site:w',
                'o{orgId}-siteGeneral:r',
                'o{orgId}-siteGeneral:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
          ],
        },
        {
          key: entriesTableRoute,
          get title() {
            return t('Entries');
          },
          route: entriesTableRoute,
          scope: [
            'o{orgId}-site:r',
            'o{orgId}-site:w',
            'o{orgId}-siteGeneral:r',
            'o{orgId}-siteGeneral:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
        },
        {
          key: entryStatesTableRoute,
          get title() {
            return t('Entry states');
          },
          route: entryStatesTableRoute,
          hidden: mergedOpenpathConfig.ENTRY_STATES_MENU_ITEM_HIDDEN,
          scope: [
            'o{orgId}-site:r',
            'o{orgId}-site:w',
            'o{orgId}-entryState:r',
            'o{orgId}-entryState:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          items: [
            {
              key: entryStatesCreateRoute,
              get title() {
                return t('Create entry state');
              },
              route: entryStatesCreateRoute,
              scope: [
                'o{orgId}-site:r',
                'o{orgId}-site:w',
                'o{orgId}-entryState:r',
                'o{orgId}-entryState:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: entryStatesEditRoute,
              get title() {
                return t('Edit entry state');
              },
              route: entryStatesEditRoute,
              scope: [
                'o{orgId}-site:r',
                'o{orgId}-site:w',
                'o{orgId}-entryState:r',
                'o{orgId}-entryState:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
          ],
        },
        {
          key: entrySchedulesTableRoute,
          get title() {
            return t('Entry schedules');
          },
          route: entrySchedulesTableRoute,
          scope: [
            'o{orgId}-site:r',
            'o{orgId}-site:w',
            'o{orgId}-siteGeneral:r',
            'o{orgId}-siteGeneral:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          items: [
            {
              key: entrySchedulesCreateRoute,
              get title() {
                return t('Create schedule');
              },
              route: entrySchedulesCreateRoute,
              scope: [
                'o{orgId}-site:r',
                'o{orgId}-site:w',
                'o{orgId}-siteGeneral:r',
                'o{orgId}-siteGeneral:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: entrySchedulesEditRoute,
              get title() {
                return t('Edit schedule');
              },
              route: entrySchedulesEditRoute,
              scope: [
                'o{orgId}-site:r',
                'o{orgId}-site:w',
                'o{orgId}-siteGeneral:r',
                'o{orgId}-siteGeneral:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
          ],
        },
        {
          key: lockdownTableRoute,
          get title() {
            return t('Lockdown plans');
          },
          route: lockdownTableRoute,
          scope: [
            'o{orgId}-ldp:r',
            'o{orgId}-ldp:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          items: [
            {
              key: lockdownCreateRoute,
              get title() {
                return t('Create lockdown plan');
              },
              route: lockdownCreateRoute,
              scope: [
                'o{orgId}-ldp:r',
                'o{orgId}-ldp:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: lockdownEditRoute,
              get title() {
                return t('Edit lockdown plan');
              },
              route: lockdownEditRoute,
              scope: [
                'o{orgId}-ldp:r',
                'o{orgId}-ldp:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: lockdownEditConfigRoute,
              get title() {
                return t('Edit lockdown user config');
              },
              route: lockdownEditConfigRoute,
              scope: [
                'o{orgId}-ldp:r',
                'o{orgId}-ldp:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
          ],
        },
      ],
    },

    {
      key: 'primary-devices',
      get title() {
        return t('Devices');
      },
      icon: <DevicesOutlinedSvg />,
      selectedIcon: <DeviceFilledSvg />,
      scope: ['o{orgId}-hw:r', 'o{orgId}-hw:w', 'o:w', 'o:r', 's-o:r', 's-o:w'],
      items: [
        {
          key: acusTableRoute,
          get title() {
            return t('ACUs');
          },
          route: acusTableRoute,
          scope: [
            'o{orgId}-hw:r',
            'o{orgId}-hw:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          items: [
            {
              key: acusCreateRoute,
              get title() {
                return t('Create ACU');
              },
              route: acusCreateRoute,
              scope: [
                'o{orgId}-hw:r',
                'o{orgId}-hw:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: acusEditRoute,
              get title() {
                return t('Edit ACU');
              },
              route: acusEditRoute,
              scope: [
                'o{orgId}-hw:r',
                'o{orgId}-hw:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: acusPortsRoute,
              get title() {
                return t('Edit ACU ports');
              },
              route: acusPortsRoute,
              scope: [
                'o{orgId}-hw:r',
                'o{orgId}-hw:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
          ],
        },
        {
          key: readersTableRoute,
          get title() {
            return t('Readers');
          },
          route: readersTableRoute,
          scope: [
            'o{orgId}-hw:r',
            'o{orgId}-hw:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          items: [
            {
              key: readersCreateRoute,
              get title() {
                return t('Create reader');
              },
              route: readersCreateRoute,
              scope: [
                'o{orgId}-hw:r',
                'o{orgId}-hw:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: readersEditRoute,
              get title() {
                return t('Edit reader');
              },
              route: readersEditRoute,
              scope: [
                'o{orgId}-hw:r',
                'o{orgId}-hw:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: allegionReadersTableRoute,
              get title() {
                return t('Third-party readers');
              },
              route: allegionReadersTableRoute,
              scope: [
                'o{orgId}-hw:r',
                'o{orgId}-hw:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: thirdPartyReadersEditRoute,
              get title() {
                return t('Edit third-party reader');
              },
              route: thirdPartyReadersEditRoute,
              scope: [
                'o{orgId}-hw:r',
                'o{orgId}-hw:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
          ],
        },
        {
          key: videoReadersRoute,
          get title() {
            return t('Video readers');
          },
          route: videoReadersRoute,
          scope: [
            'o{orgId}-hw:r',
            'o{orgId}-hw:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
        },
        {
          key: videoIntercomReadersRoute,
          get title() {
            return t('Intercoms');
          },
          route: videoIntercomReadersRoute,
          scope: [
            'o{orgId}-hw:r',
            'o{orgId}-hw:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
        },
        {
          key: wirelessLocksTableRoute,
          get title() {
            return t('Wireless locks');
          },
          route: wirelessLocksTableRoute,
          scope: [
            'o{orgId}-hw:r',
            'o{orgId}-hw:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          items: [
            {
              key: wirelessLocksEditRoute,
              get title() {
                return t('Edit wireless lock');
              },
              route: wirelessLocksEditRoute,
              scope: [
                'o{orgId}-hw:r',
                'o{orgId}-hw:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: allegionWirelessLocksTableRoute,
              get title() {
                return t('Allegion wireless locks');
              },
              route: allegionWirelessLocksTableRoute,
              scope: [
                'o{orgId}-hw:r',
                'o{orgId}-hw:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: assaAbloyWirelessLocksTableRoute,
              get title() {
                return t('Assa Abloy wireless locks');
              },
              route: assaAbloyWirelessLocksTableRoute,
              scope: [
                'o{orgId}-hw:r',
                'o{orgId}-hw:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
          ],
        },
        {
          key: wirelessLockGatewaysTableRoute,
          get title() {
            return t('Wireless gateways');
          },
          route: wirelessLockGatewaysTableRoute,
          scope: [
            'o{orgId}-hw:r',
            'o{orgId}-hw:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          items: [
            {
              key: allegionWirelessLockGatewaysTableRoute,
              get title() {
                return t('Allegion wireless gateways');
              },
              route: allegionWirelessLockGatewaysTableRoute,
              scope: [
                'o{orgId}-hw:r',
                'o{orgId}-hw:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: assaAbloyWirelessLockGatewaysTableRoute,
              get title() {
                return t('Assa Abloy wireless gateways');
              },
              route: assaAbloyWirelessLockGatewaysTableRoute,
              scope: [
                'o{orgId}-hw:r',
                'o{orgId}-hw:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
          ],
        },
        {
          key: deviceUpdateManagement,
          get title() {
            return t('Updates');
          },
          route: deviceUpdateManagement,
          scope: [
            'o{orgId}-hw:r',
            'o{orgId}-hw:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
        },
      ],
    },

    {
      key: 'primary-reports',
      get title() {
        return t('Reports');
      },
      icon: <FileOutlinedSvg />,
      selectedIcon: <FileFilledSvg />,
      scope: [
        'o{orgId}-rpt:r',
        'o{orgId}-rpt:w',
        'o{orgId}-rptGeneral:r',
        'o{orgId}-rptGeneral:w',
        'o{orgId}-musterReport:r',
        'o{orgId}-musterReport:w',
        'o{orgId}-occupancyReport:r',
        'o{orgId}-occupancyReport:w',
        'o{orgId}-entryAccessAudit:r',
        'o{orgId}-entryAccessAudit:w',
        'o{orgId}-portalAudit:r',
        'o{orgId}-portalAudit:w',
        'o{orgId}-credential:r',
        'o{orgId}-credential:w',
        'o:w',
        'o:r',
        's-o:r',
        's-o:w',
      ],
      items: [
        {
          key: 'reports-misc-group',
          type: 'group',
          title: '',
          items: [
            {
              key: alarmReportRoute,
              get title() {
                return t('Alarms');
              },
              route: alarmReportRoute,
              scope: [
                'o{orgId}-rpt:r',
                'o{orgId}-rpt:w',
                'o{orgId}-rptAlarm:r',
                'o{orgId}-rptAlarm:w',
                'o:w',
                'o:r',
              ],
            },
            {
              key: userCredentialsManagementRoute,
              get title() {
                return t('Credentials');
              },
              route: userCredentialsManagementRoute,
              scope: [
                'o{orgId}-rpt:r',
                'o{orgId}-rpt:w',
                'o{orgId}-credential:r',
                'o{orgId}-credential:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
            },
            {
              key: musterReportsRoute,
              get title() {
                return t('Muster');
              },
              route: musterReportsRoute,
              scope: [
                'o{orgId}-rpt:r',
                'o{orgId}-rpt:w',
                'o{orgId}-musterReport:r',
                'o{orgId}-musterReport:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
            },
            {
              key: occupancyReportRoute,
              get title() {
                return t('Occupancy');
              },
              route: occupancyReportRoute,
              scope: [
                'o{orgId}-rpt:r',
                'o{orgId}-rpt:w',
                'o{orgId}-occupancyReport:r',
                'o{orgId}-occupancyReport:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
            },
            {
              key: scheduledReportsRoute,
              get title() {
                return t('Scheduled');
              },
              route: scheduledReportsRoute,
              scope: [
                'o{orgId}-rpt:r',
                'o{orgId}-rpt:w',
                'o{orgId}-rptGeneral:w',
                'o{orgId}-rptGeneral:r',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: mergedOpenpathConfig.SCHEDULED_REPORTS_DISABLED,
              items: [
                {
                  key: scheduledReportsCreateRoute,
                  get title() {
                    return t('Create scheduled report');
                  },
                  route: scheduledReportsCreateRoute,
                  scope: [
                    'o{orgId}-rpt:r',
                    'o{orgId}-rpt:w',
                    'o{orgId}-credential:r',
                    'o{orgId}-credential:w',
                    'o:w',
                    'o:r',
                    's-o:r',
                    's-o:w',
                  ],
                  hidden: true,
                },
                {
                  key: scheduledReportsEditRoute,
                  get title() {
                    return t('Edit scheduled report');
                  },
                  route: scheduledReportsEditRoute,
                  scope: [
                    'o{orgId}-rpt:r',
                    'o{orgId}-rpt:w',
                    'o{orgId}-credential:r',
                    'o{orgId}-credential:w',
                    'o:w',
                    'o:r',
                    's-o:r',
                    's-o:w',
                  ],
                  hidden: true,
                },
              ],
            },
            {
              key: presenceReportRoute,
              get title() {
                return t('Presence');
              },
              route: presenceReportRoute,
              scope: [
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
                'o{orgId}-presence:r',
                'o{orgId}-presence:w',
              ],
              hidden: mergedOpenpathConfig.PRESENCE_HIDDEN,
            },
          ],
        },

        {
          key: 'reports-activity-group',
          type: 'group',
          get title() {
            return t('Activity');
          },
          items: [
            {
              key: activityLogsRoute,
              get title() {
                return t('Logs');
              },
              route: activityLogsRoute,
              scope: [
                'o{orgId}-rpt:r',
                'o{orgId}-rpt:w',
                'o{orgId}-rptGeneral:r',
                'o{orgId}-rptGeneral:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
            },
            {
              key: entryActivityRoute,
              get title() {
                return t('Entry');
              },
              route: entryActivityRoute,
              scope: [
                'o{orgId}-rpt:r',
                'o{orgId}-rpt:w',
                'o{orgId}-rptGeneral:r',
                'o{orgId}-rptGeneral:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
            },
            {
              key: entryActivitySummaryRoute,
              get title() {
                return t('Entry summary');
              },
              route: entryActivitySummaryRoute,
              scope: [
                'o{orgId}-rpt:r',
                'o{orgId}-rpt:w',
                'o{orgId}-rptGeneral:r',
                'o{orgId}-rptGeneral:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
            },
            {
              key: userActivityRoute,
              get title() {
                return t('User');
              },
              route: userActivityRoute,
              scope: [
                'o{orgId}-rpt:r',
                'o{orgId}-rpt:w',
                'o{orgId}-rptGeneral:r',
                'o{orgId}-rptGeneral:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
            },
            {
              key: userActivitySummaryRoute,
              get title() {
                return t('User summary');
              },
              route: userActivitySummaryRoute,
              scope: [
                'o{orgId}-rpt:r',
                'o{orgId}-rpt:w',
                'o{orgId}-rptGeneral:r',
                'o{orgId}-rptGeneral:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
            },
            {
              key: visualActivityReportRoute,
              get title() {
                return t('Visual event');
              },
              route: visualActivityReportRoute,
              scope: [
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
                'o{orgId}-videoProviderPlayback:w',
              ],
              hidden: !mergedOpenpathConfig.SHOW_VISUAL_ACTIVITY_REPORT,
            },
          ],
        },

        {
          key: 'reports-audit-group',
          type: 'group',
          get title() {
            return t('Audits');
          },
          items: [
            {
              key: entryAccessAuditRoute,
              get title() {
                return t('Entry access');
              },
              route: entryAccessAuditRoute,
              scope: [
                'o{orgId}-rpt:r',
                'o{orgId}-rpt:w',
                'o{orgId}-entryAccessAudit:r',
                'o{orgId}-entryAccessAudit:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
            },
            {
              key: userAccessAuditRoute,
              get title() {
                return t('User access');
              },
              route: userAccessAuditRoute,
              scope: [
                'o{orgId}-rpt:r',
                'o{orgId}-rpt:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
            },
            {
              key: portalAuditReportRoute,
              get title() {
                return t('Portal');
              },
              route: portalAuditReportRoute,
              scope: [
                'o{orgId}-rpt:r',
                'o{orgId}-rpt:w',
                'o{orgId}-portalAudit:r',
                'o{orgId}-portalAudit:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: mergedOpenpathConfig.API_AUDIT_REPORT_HIDDEN,
            },
          ],
        },
      ],
    },

    {
      key: 'primary-apps',
      get title() {
        return t('Apps');
      },
      icon: <PuzzleOutlinedSvg />,
      selectedIcon: <PuzzleFilledSvg />,
      scope: [
        'o{orgId}-integrations:r',
        'o{orgId}-integrations:w',
        'o:w',
        'o:r',
        's-o:r',
        's-o:w',
      ],
      hidden:
        mergedOpenpathConfig.APP_MARKETPLACE_DISABLED ||
        (!isLicenseBased && !hasAppMarketplace),
      items: [
        {
          key: appMarketplaceRoute,
          get title() {
            return t('Get apps');
          },
          route: appMarketplaceRoute,
          scope: [
            'o{orgId}-integrations:r',
            'o{orgId}-integrations:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
        },
        {
          key: myAppsTableRoute,
          get title() {
            return t('My apps');
          },
          route: myAppsTableRoute,
          scope: [
            'o{orgId}-integrations:r',
            'o{orgId}-integrations:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
        },
      ],
    },

    {
      key: integrationsRoute,
      get title() {
        return t('Apps');
      },
      route: integrationsRoute,
      icon: <PuzzleOutlinedSvg />,
      selectedIcon: <PuzzleFilledSvg />,
      hidden:
        mergedOpenpathConfig.INTEGRATIONS_MENU_ITEM_HIDDEN ||
        isLicenseBased ||
        hasAppMarketplace,
      scope: [
        'o{orgId}-integrations:r',
        'o{orgId}-integrations:w',
        'o:w',
        'o:r',
        's-o:r',
        's-o:w',
      ],
      items: [
        {
          key: integrationsIdentityProviderGsuite,
          get title() {
            return t('GSuite');
          },
          route: integrationsIdentityProviderGsuite,
          scope: [
            'o{orgId}-integrations:r',
            'o{orgId}-integrations:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          hidden: true,
        },
        {
          key: integrationsIdentityProviderAzure,
          get title() {
            return t('Azure');
          },
          route: integrationsIdentityProviderAzure,
          scope: [
            'o{orgId}-integrations:r',
            'o{orgId}-integrations:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          hidden: true,
        },
        {
          key: integrationsIdentityProviderOkta,
          get title() {
            return t('Okta');
          },
          route: integrationsIdentityProviderOkta,
          scope: [
            'o{orgId}-integrations:r',
            'o{orgId}-integrations:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          hidden: true,
        },
        {
          key: integrationsIdentityProviderOnelogin,
          get title() {
            return t('Onelogin');
          },
          route: integrationsIdentityProviderOnelogin,
          scope: [
            'o{orgId}-integrations:r',
            'o{orgId}-integrations:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          hidden: true,
        },
      ],
    },

    {
      key: 'primary-config',
      get title() {
        return t('Config');
      },
      icon: <SettingOutlinedSvg />,
      selectedIcon: <SettingFilledSvg />,
      scope: [
        'o{orgId}-configurations:r',
        'o{orgId}-configurations:w',
        'o{orgId}-alarmConfigurations:r',
        'o{orgId}-alarmConfigurations:w',
        'o{orgId}-outboundWebhooks:r',
        'o{orgId}-outboundWebhooks:w',
        'o{orgId}-alertSettings:r',
        'o{orgId}-alertSettings:w',
        'o{orgId}-mobileAppSettings:r',
        'o{orgId}-mobileAppSettings:w',
        'o{orgId}-badgePrinting:r',
        'o{orgId}-badgePrinting:w',
        'o:w',
        'o:r',
        's-o:r',
        's-o:w',
      ],
      items: [
        {
          key: alarmConfigurationsRoute,
          get title() {
            return t('Alarms');
          },
          route: alarmConfigurationsRoute,
          scope: [
            'o{orgId}-configurations:r',
            'o{orgId}-configurations:w',
            'o{orgId}-alarmConfigurations:r',
            'o{orgId}-alarmConfigurations:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
        },
        {
          key: subscriptionsTableRoute,
          get title() {
            return t('Rules');
          },
          route: subscriptionsTableRoute,
          scope: [
            'o{orgId}-configurations:r',
            'o{orgId}-configurations:w',
            'o{orgId}-outboundWebhooks:r',
            'o{orgId}-outboundWebhooks:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          items: [
            {
              key: subscriptionsCreateRoute,
              get title() {
                return t('Create rule');
              },
              route: subscriptionsCreateRoute,
              scope: [
                'o{orgId}-configurations:r',
                'o{orgId}-configurations:w',
                'o{orgId}-outboundWebhooks:r',
                'o{orgId}-outboundWebhooks:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
            {
              key: subscriptionsEditRoute,
              get title() {
                return t('Edit rule');
              },
              route: subscriptionsEditRoute,
              scope: [
                'o{orgId}-configurations:r',
                'o{orgId}-configurations:w',
                'o{orgId}-outboundWebhooks:r',
                'o{orgId}-outboundWebhooks:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
          ],
        },
        {
          key: alertSettingsRoute,
          get title() {
            return t('Alerts');
          },
          route: alertSettingsRoute,
          hidden: mergedOpenpathConfig.ALERTS_SETTINGS_MENU_ITEM_HIDDEN,
          scope: [
            'o{orgId}-configurations:r',
            'o{orgId}-configurations:w',
            'o{orgId}-alertSettings:r',
            'o{orgId}-alertSettings:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
        },
        {
          key: mobileAppSettingsRoute,
          get title() {
            return t('Mobile app');
          },
          route: mobileAppSettingsRoute,
          hidden: mergedOpenpathConfig.ADMINISTRATION_MENU_ITEM_HIDDEN,
          scope: [
            'o{orgId}-configurations:r',
            'o{orgId}-configurations:w',
            'o{orgId}-mobileAppSettings:r',
            'o{orgId}-mobileAppSettings:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          items: [
            {
              key: mobileAppBadgeUiRoute,
              get title() {
                return t('Badge UI');
              },
              route: mobileAppBadgeUiRoute,
              scope: [
                'o{orgId}-configurations:r',
                'o{orgId}-configurations:w',
                'o{orgId}-mobileAppSettings:r',
                'o{orgId}-mobileAppSettings:w',
                'o:w',
                'o:r',
                's-o:r',
                's-o:w',
              ],
              hidden: true,
            },
          ],
        },
        {
          key: badgeTemplatesTablePageRoute,
          get title() {
            return t('Badge templates');
          },
          route: badgeTemplatesTablePageRoute,
          requiredFeatureCode: 'badgePrinting',
          scope: [
            'o{orgId}-configurations:r',
            'o{orgId}-configurations:w',
            'o{orgId}-badgePrinting:r',
            'o{orgId}-badgePrinting:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
        },
        {
          key: wirelessLockTemplatesRoute,
          get title() {
            return t('Lock templates');
          },
          route: wirelessLockTemplatesRoute,
          scope: [
            'o{orgId}-hw:r',
            'o{orgId}-hw:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          hidden: !isWirelessLockTemplatesEnabled,
        },
        {
          key: intercomUserDirectoryRoute,
          get title() {
            return t('Intercom users');
          },
          route: intercomUserDirectoryRoute,
          scope: [
            'o{orgId}-configurations:r',
            'o{orgId}-configurations:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
        },
      ],
    },

    {
      key: 'primary-admin',
      get title() {
        return t('Admin');
      },
      icon: <AdminOutlinedSvg />,
      selectedIcon: <AdminFilledSvg />,
      scope: [
        'o{orgId}-admin:r',
        'o{orgId}-admin:w',
        'o{orgId}-account:r',
        'o{orgId}-account:w',
        'o{orgId}-quickStart:r',
        'o{orgId}-quickStart:w',
        'o:w',
        'o:r',
        's-o:r',
        's-o:w',
      ],
      items: [
        {
          key: accountPageRoute,
          get title() {
            return t('Account');
          },
          route: accountPageRoute,
          scope: [
            'o{orgId}-serviceCancellation:w',
            'o{orgId}-admin:r',
            'o{orgId}-admin:w',
            'o{orgId}-account:r',
            'o{orgId}-account:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
        },
        {
          key: licensesRoute,
          get title() {
            return t('Requests');
          },
          route: licensesRoute,
          scope: [
            'o{orgId}-integrations:r',
            'o{orgId}-integrations:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          hidden:
            mergedOpenpathConfig.APP_MARKETPLACE_DISABLED ||
            isLicenseBased ||
            !hasAppMarketplace ||
            (hasAppMarketplace && billingMode !== 'channel'),
        },
        {
          key: licensesRoute,
          get title() {
            return t('Licenses');
          },
          route: licensesRoute,
          scope: [
            'o{orgId}-integrations:r',
            'o{orgId}-integrations:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
          hidden:
            mergedOpenpathConfig.APP_MARKETPLACE_DISABLED || !isLicenseBased,
        },
        {
          key: quickStartRoute,
          get title() {
            return t('Quick start');
          },
          route: quickStartRoute,
          scope: [
            'o{orgId}-admin:r',
            'o{orgId}-admin:w',
            'o{orgId}-quickStart:r',
            'o{orgId}-quickStart:w',
            'o:w',
            'o:r',
            's-o:r',
            's-o:w',
          ],
        },
      ],
    },

    {
      key: releaseNotesRoute,
      get title() {
        return t('Releases');
      },
      route: releaseNotesRoute,
      icon:
        newReleaseNotesCount > 0 ? (
          <Badge dot>
            <DocumentOutlinedSvg />
          </Badge>
        ) : (
          <DocumentOutlinedSvg />
        ),
      selectedIcon:
        newReleaseNotesCount > 0 ? (
          <Badge dot>
            <DocumentFilledSvg />
          </Badge>
        ) : (
          <DocumentFilledSvg />
        ),
      scope: [
        'o{orgId}-admin:r',
        'o{orgId}-admin:w',
        'o:w',
        'o:r',
        's-o:r',
        's-o:w',
      ],
      hidden: true,
    },

    /**
     * Master mode top level menu items
     */
    {
      admin: true,
      key: masterDashboardRoute,
      get title() {
        return t('Home');
      },
      route: masterDashboardRoute,
      icon: <HomeOutlinedSvg />,
      selectedIcon: <HomeFilledSvg />,
      scope: [
        'o:r',
        'o:w',
        'o-basic:r',
        'o-basic:w',
        'i:r',
        'i:w',
        's-o:r',
        's-o:w',
      ],
    },

    {
      admin: true,
      key: 'master-primary-manage',
      get title() {
        return t('Manage');
      },
      icon: <AdminOutlinedSvg />,
      selectedIcon: <AdminFilledSvg />,
      scope: [
        'o:r',
        'o:w',
        'o-basic:r',
        'o-basic:w',
        's-o:r',
        's-o:w',
        'o-support:r',
        'o-support:w',
        'i:r',
        'i:w',
      ],
      items: [
        {
          admin: true,
          key: masterOrgTableRoute,
          get title() {
            return t('Orgs');
          },
          route: masterOrgTableRoute,
          scope: [
            'o:r',
            'o:w',
            'o-basic:r',
            'o-basic:w',
            's-o:r',
            's-o:w',
            'o-support:r',
            'o-support:w',
          ],
          items: [
            {
              admin: true,
              key: masterOrgCreateRoute,
              get title() {
                return t('Create organization');
              },
              route: masterOrgCreateRoute,
              scope: ['o:w', 'o-basic:w', 's-o:w'],
              hidden: true,
            },
            {
              admin: true,
              key: masterOrgEditRoute,
              get title() {
                return t('Edit organization');
              },
              route: masterOrgEditRoute,
              scope: ['o:r', 'o:w', 'o-basic:r', 'o-basic:w', 's-o:r', 's-o:w'],
              hidden: true,
            },
            {
              admin: true,
              key: masterOrgEditPackageRoute,
              get title() {
                return t('Edit organization package');
              },
              route: masterOrgEditPackageRoute,
              scope: ['o:r', 'o:w', 'o-basic:r', 'o-basic:w', 's-o:r', 's-o:w'],
              hidden: true,
            },
            {
              admin: true,
              key: masterOrgEditFeatureFlagRoute,
              get title() {
                return t('Edit organization feature flag');
              },
              route: masterOrgEditFeatureFlagRoute,
              scope: [
                'o:r',
                'o:w',
                's-o:r',
                's-o:w', // Writes will fail for s-o but they can still view them here...
                'o-support:r',
                'o-support:w',
              ],
              hidden: true,
            },
          ],
        },

        {
          admin: true,
          key: masterCancelsTableRoute,
          get title() {
            return t('Cancels');
          },
          route: masterCancelsTableRoute,
          scope: [
            'o:r',
            'o:w',
            'o-basic:w',
            'o-basic:r',
            'o-support:r',
            'o-support:w',
            's-o:w',
            's-o:r',
          ],
        },

        {
          admin: true,
          key: masterIdentitiesTableRoute,
          get title() {
            return t('Identities');
          },
          route: masterIdentitiesTableRoute,
          scope: ['i:r', 'i:w'],
          items: [
            {
              admin: true,
              key: masterIdentitiesEditRoute,
              get title() {
                return t('Edit Identity');
              },
              route: masterIdentitiesEditRoute,
              scope: ['i:r', 'i:w'],
              hidden: true,
            },
            {
              admin: true,
              key: masterIdentitiesEditSecurityRoute,
              get title() {
                return t('Edit identity security');
              },
              route: masterIdentitiesEditSecurityRoute,
              scope: ['i:r', 'i:w'],
              hidden: true,
            },
            {
              admin: true,
              key: masterIdentitiesCreateRoute,
              get title() {
                return t('Create identity');
              },
              route: masterIdentitiesCreateRoute,
              scope: ['i:r', 'i:w'],
              hidden: true,
            },
          ],
        },

        {
          admin: true,
          key: masterRolesTableRoute,
          get title() {
            return t('Identity roles');
          },
          route: masterRolesTableRoute,
          scope: ['i:r', 'i:w'],
          items: [
            {
              admin: true,
              key: masterRolesEditRoute,
              get title() {
                return t('Edit role');
              },
              route: masterRolesEditRoute,
              scope: ['i:r', 'i:w'],
              hidden: true,
            },
            {
              admin: true,
              key: masterRolesCreateRoute,
              get title() {
                return t('Create role');
              },
              route: masterRolesCreateRoute,
              scope: ['i:r', 'i:w'],
              hidden: true,
            },
          ],
        },

        {
          admin: true,
          key: masterAcusTableRoute,
          get title() {
            return t('ACUs');
          },
          route: masterAcusTableRoute,
          scope: ['o:r', 'o:w', 's-o:r', 's-o:w'],
          items: [
            {
              admin: true,
              key: masterAcusEditRoute,
              get title() {
                return t('View ACU');
              },
              route: masterAcusEditRoute,
              scope: ['o:r', 'o:w', 's-o:r', 's-o:w'],
              hidden: true,
            },
          ],
        },

        {
          admin: true,
          key: masterEntriesTableRoute,
          get title() {
            return t('Entries');
          },
          route: masterEntriesTableRoute,
          scope: ['o:r', 'o:w'], // no s-o here, since this page is new and we are migrating partners into Partner Center
        },

        {
          admin: true,
          key: masterThirdPartyDevicesRoute,
          get title() {
            return t('3rd-party devices');
          },
          route: masterThirdPartyDevicesRoute,
          scope: ['o:r', 'o:w', 's-o:r', 's-o:w'],
        },

        {
          admin: true,
          key: masterAllegionFobsRoute,
          get title() {
            return t('Allegion fobs');
          },
          route: masterAllegionFobsRoute,
          scope: ['o:r', 'o:w'],
        },

        {
          admin: true,
          key: masterFeatureFlagsTableRoute,
          get title() {
            return t('Feature flags');
          },
          route: masterFeatureFlagsTableRoute,
          scope: ['o:r', 'o:w', 'o-support:r', 'o-support:w'],
          items: [
            {
              admin: true,
              key: masterFeatureFlagsCreateRoute,
              get title() {
                return t('Create feature flag');
              },
              route: masterFeatureFlagsCreateRoute,
              scope: ['o:w', 'o-support:w'],
              hidden: true,
            },
            {
              admin: true,
              key: masterFeatureFlagsEditRoute,
              get title() {
                return t('Edit feature flag');
              },
              route: masterFeatureFlagsEditRoute,
              scope: ['o:r', 'o:w', 'o-support:r', 'o-support:w'],
              hidden: true,
            },
          ],
        },
      ],
    },

    {
      admin: true,
      key: 'master-primary-reports',
      get title() {
        return t('Reports');
      },
      icon: <FileOutlinedSvg />,
      selectedIcon: <FileFilledSvg />,
      scope: ['o:r', 'o:w', 'o-support:r', 'o-support:w', 'o-acu:r', 'o-acu:w'],
      items: [
        {
          admin: true,
          key: masterPortalAuditReportRoute,
          get title() {
            return t('System audit');
          },
          route: masterPortalAuditReportRoute,
          scope: ['o:r', 'o:w', 'o-support:r', 'o-support:w'],
        },

        {
          admin: true,
          key: masterAcuSoftwareReportRoute,
          get title() {
            return t('ACU software');
          },
          route: masterAcuSoftwareReportRoute,
          scope: [
            'o:r',
            'o:w',
            'o-acu:r',
            'o-acu:w',
            'o-support:r',
            'o-support:w',
          ],
        },

        {
          admin: true,
          key: masterMobileWalletReportRoute,
          get title() {
            return t('Mobile wallet');
          },
          route: masterMobileWalletReportRoute,
          scope: ['o:r', 'o:w', 'o-support:r', 'o-support:w'],
        },
      ],
    },

    {
      admin: true,
      key: masterReleaseNotesRoute,
      get title() {
        return t('Releases');
      },
      route: masterReleaseNotesRoute,
      icon:
        newMasterReleaseNotesCount > 0 ? (
          <Badge dot>
            <DocumentOutlinedSvg />
          </Badge>
        ) : (
          <DocumentOutlinedSvg />
        ),
      selectedIcon:
        newMasterReleaseNotesCount > 0 ? (
          <Badge dot>
            <DocumentFilledSvg />
          </Badge>
        ) : (
          <DocumentFilledSvg />
        ),
      scope: ['o:r', 'o:w', 's-o:r', 's-o:w'],
    },

    {
      admin: true,
      key: 'master-primary-resources',
      get title() {
        return t('Resources');
      },
      icon: <QuestionMarkOutlinedSvg />,
      selectedIcon: <QuestionMarkFilledSvg />,
      scope: ['s-o:r', 's-o:w'],
      items: [
        {
          admin: true,
          key: 'master-secondary-marketing',
          get title() {
            return t('Marketing');
          },
          route: 'https://vsapartners.motorolasolutions.com/s/',
          scope: ['s-o:r', 's-o:w'],
          external: true,
        },

        {
          admin: true,
          key: 'https://www.openpath.com/openpath-university',
          get title() {
            return t('Training');
          },
          route: 'https://www.openpath.com/openpath-university',
          scope: ['s-o:r', 's-o:w'],
          external: true,
        },
      ],
    },

    /**
     * Hidden top level menu items
     */
    {
      key: requiredTermsRoute,
      get title() {
        return t('Required terms');
      },
      route: requiredTermsRoute,
      hidden: true,
    },

    // Can open from anywhere, not a real page, just a slideout!
    {
      key: alarmEditRoute,
      get title() {
        return t('Alarm edit');
      },
      route: alarmEditRoute,
      scope: [
        'o{orgId}-dash:r',
        'o{orgId}-dash:w',
        'o{orgId}-dashAlarm:r',
        'o{orgId}-dashAlarm:w',
        'o{orgId}-rpt:r',
        'o{orgId}-rpt:w',
        'o{orgId}-rptAlarm:r',
        'o{orgId}-rptAlarm:w',
        'o{orgId}-configurations:r',
        'o{orgId}-configurations:w',
        'o{orgId}-alarmActions:r',
        'o{orgId}-alarmActions:w',
        'o:r',
        'o:w',
      ],
      hidden: true,
    },

    {
      key: 'developer-menu',
      hidden: true,
      // hidden: !mergedOpenpathConfig.SHOW_DEVELOPER_MENU,
      get title() {
        return t('Developer menu');
      },
      scope: [],
      items: [
        {
          key: 'https://react.semantic-ui.com/',
          get title() {
            return t('Semantic UI react (docs)');
          },
          external: true,
          route: 'https://react.semantic-ui.com/',
          scope: [],
        },
      ],
    },
  ] satisfies OpRawMenuItemType[];
};
